// import { ProgramSessionSetCreateRequest, SetSearchFilter, ProgramSessionSetSearchResponse, ProgramSessionSet } from '@api/entities';
import { ProgramSessionSet, ProgramSessionSetCreateRequest, ProgramSessionSetSearchRequest, ProgramSessionSetSearchResponse, SetSearchFilter } from 'src/api/entities';
import { IWorkoutSessionSetApiService, WorkoutSessionSetApiService } from '../services/workoutSessionSet/workout.session.set.client.api.service';

export interface IWorkoutSessionSetManager {
    search(page: number, size: number, query?: string, sort?: { [key: string]: string | undefined }, filter?: SetSearchFilter): Promise<ProgramSessionSetSearchResponse>;
    create(workoutID: number, request: ProgramSessionSetCreateRequest): Promise<ProgramSessionSet> ;
    searchByExerciseUuid(setSearchRequest: ProgramSessionSetSearchRequest, exerciseUuid: string): Promise<ProgramSessionSet[]>;
}

export class WorkoutSessionSetManager implements IWorkoutSessionSetManager {
    private static instance: WorkoutSessionSetManager;
    private workoutService: IWorkoutSessionSetApiService;

    private constructor() {
        this.workoutService = WorkoutSessionSetApiService.getInstance(process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!);
    }

    static getInstance() {
        if (WorkoutSessionSetManager.instance == null) {
            WorkoutSessionSetManager.instance = new WorkoutSessionSetManager();
        }
        return WorkoutSessionSetManager.instance;
    }

    async search(workoutID?: number): Promise<ProgramSessionSetSearchResponse> {
      const filter : SetSearchFilter = {
        sessionID: workoutID
      }  
      
      const response: ProgramSessionSetSearchResponse = await this.workoutService.search(
          0, 
          100, 
          undefined, 
          undefined, 
          filter);
        return response;
    }

    async create(workoutID: number, request: ProgramSessionSetCreateRequest): Promise<ProgramSessionSet> {
        const response = await this.workoutService.create(workoutID, request)
        return response;
    }

    async edit(oldExercise: ProgramSessionSet, updatedExercise: ProgramSessionSet): Promise<ProgramSessionSet> {
        const response = await this.workoutService.edit(oldExercise, updatedExercise)
        return response;
    }
  
    async getByID(id: number): Promise<ProgramSessionSet> {
        const response = await this.workoutService.getById(id)
        return response;
    }

    async searchByExerciseUuid(setSearchRequest: ProgramSessionSetSearchRequest, exerciseUuid: string): Promise<ProgramSessionSet[]> {
        const response = await this.workoutService.searchByExerciseUuid(setSearchRequest, exerciseUuid)
        return response;
    }
  
    async delete(uuid: string): Promise<{ [key: string]: boolean; }> {
        const response = await this.workoutService.deleteByUuid(uuid)
        return response;
    }
}
